import { sleep } from "@shared/utils/tools.ts";

import json from "../../json/domains.json";

export default async () => {
  await sleep(350);
  return JSON.parse(JSON.stringify(json));
};
